// Čiste adrese kategorija i potkategorija: mala slova, bez kukica i razmaka.
//   "Kafići"            -> "kafici"
//   "Noćni život"       -> "nocni-zivot"
//   "Ključari & Brave"  -> "kljucari-i-brave"
// VAŽNO: ista funkcija postoji i u gen-sitemap.cjs (sitemap + preusmeravanja
// sa starih adresa). Ako se menja ovde, mora i tamo.
export function slugify(name) {
  return String(name || "")
    .toLowerCase()
    .replace(/đ/g, "dj")
    .normalize("NFD").replace(/[̀-ͯ]/g, "") // č ć š ž -> c c s z
    .replace(/&/g, " i ")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

// Nazivi kategorija iz baze koji se na sajtu zovu drugačije (obrnuto od
// CATEGORY_DB_NAME_MAP u App.js). Adresa je uvek po nazivu sa sajta, da ista
// kategorija nema dve adrese ("/kategorija/sport", nikad "/kategorija/teretane").
const DB_TO_DISPLAY = { Teretane: "Sport", Usluge: "Nega" };

// Adresa stranice kategorije (i opciono potkategorije)
export function categoryPath(category, subcategory) {
  const base = "/kategorija/" + slugify(DB_TO_DISPLAY[category] || category);
  return subcategory ? base + "/" + slugify(subcategory) : base;
}

// Pronalazi pravi naziv iz liste po delu adrese. Prihvata i stare oblike
// ("Kafići", "Kafi%C4%87i", "KAFICI"), jer se svi svode na isti slug.
export function matchBySlug(names, urlSegment) {
  let decoded = urlSegment;
  try { decoded = decodeURIComponent(urlSegment); } catch { /* ostaje kako jeste */ }
  const wanted = slugify(decoded);
  return names.find((n) => slugify(n) === wanted) || null;
}
